import { createStyles, Theme } from '@material-ui/core';
import {
  h8,
  bodyText,
  smallText,
  tinyText,
  labels,
  siteNames,
  siteNamesMedium,
  monospace,
  subtitle1,
  body1,
  body2,
  caption,
} from '#web-components/styles/text';

const styles = ({ typography }: Theme) => createStyles({
  h1: typography.h1,
  h2: typography.h2,
  h3: typography.h3,
  h4: typography.h4,
  h5: typography.h5,
  h6: typography.h6,
  h7: typography.h7,
  h8,
  textBig: typography.textBig,
  textBigCompact: typography.textBigCompact,
  textRegular: typography.textRegular,
  textRegularCompact: typography.textRegularCompact,
  textSmall: typography.textSmall,
  textSmallCompact: typography.textSmallCompact,
  textTiny: typography.textTiny,
  textTinyCompact: typography.textTinyCompact,
  accentBig: typography.accentBig,
  accentXL: typography.accentXL,
  accentBigCompact: typography.accentBigCompact,
  accentRegular: typography.accentRegular,
  accentRegularCompact: typography.accentRegularCompact,
  accentSmall: typography.accentSmall,
  accentSmallCompact: typography.accentSmallCompact,
  accentTiny: typography.accentTiny,
  accentTinyCompact: typography.accentTinyCompact,
  bodyText,
  smallText,
  tinyText,
  labels,
  siteNames,
  siteNamesMedium,
  monospace,
  subtitle1,
  body1,
  body2,
  caption,
  halfOpacity: {
    opacity: 0.5,
  },
});

export default styles;
